<h2>upp-application — App Shell</h2>
<p class="demo-description">A miniature application shell with sidebar navigation and a main content area using <code>upp-application</code>.</p>

<div class="demo-controls">
    <ion-button size="small" (click)="toggleMenu()">Menu: {{ menuMode }}</ion-button>
</div>

<div class="app-container">
    <upp-application [menu]="menuMode">
        <upp-application-menu>
            <ion-list>
                <ion-list-header>
                    <ion-label>MyApp</ion-label>
                </ion-list-header>
                <ion-item *ngFor="let nav of navItems"
                    button
                    [lines]="nav === navItems[navItems.length - 1] ? 'none' : 'full'"
                    [color]="activeNav === nav.id ? 'light' : ''"
                    (click)="selectNav(nav.id)">
                    <ion-icon [name]="nav.icon" slot="start"></ion-icon>
                    <ion-label>{{ nav.label }}</ion-label>
                </ion-item>
            </ion-list>
        </upp-application-menu>
        <upp-application-main>
            <upp-application-page>
                <upp-header color="primary" menu="hide" height="44px">
                    <upp-header-title>{{ activeNav | titlecase }}</upp-header-title>
                    <upp-header-button>
                        <ion-icon name="notifications-outline"></ion-icon>
                    </upp-header-button>
                </upp-header>
                <div class="page-content">
                    <upp-panel size="auto" lines="show">
                        <upp-panel-header>
                            <ion-item lines="none">
                                <ion-label><strong>Welcome</strong></ion-label>
                            </ion-item>
                        </upp-panel-header>
                        <upp-panel-content>
                            <ion-item lines="none">
                                <ion-label class="ion-text-wrap">
                                    You are viewing the <strong>{{ activeNav }}</strong> section.
                                    Toggle the menu or click a nav item to see the shell respond.
                                </ion-label>
                            </ion-item>
                        </upp-panel-content>
                    </upp-panel>
                </div>
            </upp-application-page>
        </upp-application-main>
    </upp-application>
</div>
